import React, { useEffect, useRef, useState } from "react";
import "./TopNav.css";
import { MessageSquareDot, Settings, FileText, Search, AlignJustify } from "lucide-react";
import {
  Avatar,
  Wrap,
  WrapItem,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  ModalCloseButton,
  useDisclosure,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Box,
  Text,
  Flex,
  IconButton,
} from "@chakra-ui/react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Searchbar from "./Searchbar";
import GlobalSearch from "../pages/AdminPannel/globalSearch/GlobalSearch";
import { FaSignOutAlt } from "@react-icons/all-files/fa/FaSignOutAlt";
import { FaUser } from "@react-icons/all-files/fa/FaUser";
import { FaCog } from "@react-icons/all-files/fa/FaCog";
import { FaBell } from "@react-icons/all-files/fa/FaBell";
import { logoutAdmin } from "../redux/reduxSlice/SingIn&Singup/AdminSingInSlice";
import { persistor } from "../redux/store/store";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { motion } from "framer-motion";

function Navbar(props) {
  const dispatch = useDispatch();
  const { isOpen: isSearchOpen, onOpen: openSearch, onClose: closeSearch } = useDisclosure();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedModule, setSelectedModule] = useState("All Modules");
  const AdminData = useSelector((state) => state.AdminSingIn.AdminSingIn || {});
  const [resultFound, setResultfound] = useState(null);
  const [isSearch, setIsSearch] = useState(false);

  // Mock notification data
  const [notifications] = useState([
    { id: 1, title: "New message", description: "You have a new message from John", time: "2 min ago" },
    { id: 2, title: "System update", description: "System maintenance scheduled for tomorrow", time: "1 hour ago" },
    { id: 3, title: "Task completed", description: "Your report has been approved", time: "3 hours ago" },
  ]);

  const [unreadNotifications, setUnreadNotifications] = useState(3);

  // #region agent log
  fetch("http://127.0.0.1:7413/ingest/1f739af4-19ea-4ba0-8a9c-4afb40c995da", {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-Debug-Session-Id": "30321d" },
    body: JSON.stringify({
      sessionId: "30321d",
      location: "TopNav.jsx:Navbar",
      message: "Admin TopNav icon/component types",
      data: {
        faSignOutType: typeof FaSignOutAlt,
        faUserType: typeof FaUser,
        chakraMenuType: typeof Menu,
      },
      timestamp: Date.now(),
      hypothesisId: "H1-default-icon-import",
      runId: "verify-post-fix",
    }),
  }).catch(() => {});
  // #endregion

  const openTrash = () => {
    openSearch();
  };

  const AdminLogutFuntion = () => {
    dispatch(logoutAdmin());
    persistor.purge();
    toast.success("Logged out successfully");
    navigate("/admin/login");
  };

  const markAllAsRead = () => {
    setUnreadNotifications(0);
    toast.success("All notifications marked as read");
  };

  return (
    <>
      <nav className="navbar" style={{ backgroundColor: "#EFF6FF" }}>
        <div className="nav-main-div">
          <button onClick={props.collapseSidenav} className="px-1" type="button" aria-label="Toggle sidebar">
            <AlignJustify />
          </button>
          <ul>
            <li>
              <div className="hover:bg-gray-200 hover:cursor-pointer p-2 rounded-full" onClick={openTrash}>
                <Search />
              </div>
            </li>

            {/* <li className="relative">
              <Menu>
                <MenuButton as={IconButton} icon={<FaBell />} variant="ghost" aria-label="Notifications" className="relative" />
                {unreadNotifications > 0 && (
                  <motion.span
                    className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ type: "spring", stiffness: 500 }}
                  >
                    {unreadNotifications}
                  </motion.span>
                )}
                <MenuList maxW="400px" minW="350px">
                  <Flex justifyContent="space-between" alignItems="center" px={4} py={2}>
                    <Text fontWeight="bold" fontSize="lg">
                      Notifications
                    </Text>
                    <Button size="xs" variant="link" colorScheme="blue" onClick={markAllAsRead}>
                      Mark all as read
                    </Button>
                  </Flex>
                  <MenuDivider />
                  <Box maxH="400px" overflowY="auto">
                    {notifications.map((notification) => (
                      <MenuItem key={notification.id} py={3} px={4} _hover={{ bg: "gray.50" }}>
                        <Flex direction="column">
                          <Flex justifyContent="space-between" w="full">
                            <Text fontWeight="semibold">{notification.title}</Text>
                            <Text fontSize="xs" color="gray.500">
                              {notification.time}
                            </Text>
                          </Flex>
                          <Text fontSize="sm" color="gray.600" mt={1}>
                            {notification.description}
                          </Text>
                        </Flex>
                      </MenuItem>
                    ))}
                  </Box>
                </MenuList>
              </Menu>
            </li> */}

            <li>
              <Settings />
            </li>

            <li>
              <Menu>
                <MenuButton>
                  <Wrap>
                    <WrapItem>
                      <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                        <Avatar size="md" name={`${AdminData?.userRes?.[0]?.firstName} ${AdminData?.userRes?.[0]?.lastName}`} bg="blue.500" color="white" src="https://bit.ly/tioluwani-kolawole" />
                      </motion.div>
                    </WrapItem>
                  </Wrap>
                </MenuButton>
                <MenuList minW="300px" py={0} overflow="hidden">
                  <Flex direction="column" bg="linear-gradient(135deg, #4f46e5, #7c3aed)" color="white" px={6} py={5}>
                    <Flex alignItems="center">
                      <Avatar size="lg" name={`${AdminData?.userRes?.[0]?.firstName} ${AdminData?.userRes?.[0]?.lastName}`} src="https://bit.ly/tioluwani-kolawole" border="2px solid white" />
                      <Box ml={4}>
                        <Text fontSize="lg" fontWeight="bold">
                          {AdminData?.userRes?.[0]?.firstName} {AdminData?.userRes?.[0]?.lastName}
                        </Text>
                        <Text fontSize="sm" opacity={0.9}>
                          {AdminData?.userRes?.[0]?.email}
                        </Text>
                        <Text fontSize="xs" mt={1} opacity={0.8}>
                          Admin Account
                        </Text>
                      </Box>
                    </Flex>
                  </Flex>

                  <Box p={4}>
                    <Flex justify="space-between" align="center" borderBottom="1px solid" borderColor="gray.100" pb={3} mb={3}>
                      <Text fontWeight="medium">Status</Text>
                      <Box bg="green.100" color="green.800" px={2} py={1} borderRadius="md" fontSize="sm">
                        Active
                      </Box>
                    </Flex>

                    {/* <Flex justify="space-between" align="center" borderBottom="1px solid" borderColor="gray.100" pb={3} mb={3}>
                      <Text fontWeight="medium">Last login</Text>
                      <Text fontSize="sm" color="gray.600">
                        2 hours ago
                      </Text>
                    </Flex> */}
                    {/* 
                    <MenuItem icon={<FaUser />} py={2} px={3} borderRadius="md" _hover={{ bg: "gray.50" }}>
                      <Text>My Profile</Text>
                    </MenuItem>

                    <MenuItem icon={<FaCog />} py={2} px={3} borderRadius="md" _hover={{ bg: "gray.50" }}>
                      <Text>Account Settings</Text>
                    </MenuItem> */}
                  </Box>

                  <MenuDivider />

                  <MenuItem icon={<FaSignOutAlt />} onClick={AdminLogutFuntion} py={3} px={5} fontWeight="medium" _hover={{ bg: "red.50", color: "red.600" }}>
                    Logout
                  </MenuItem>
                </MenuList>
              </Menu>
            </li>
          </ul>
        </div>

        <Modal isOpen={isSearchOpen} onClose={closeSearch} placement="top" size="xl">
          <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(5px)" />
          <ModalContent style={{ marginTop: "0px" }}>
            <ModalBody>
              <Searchbar
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                selectedModule={selectedModule}
                setSelectedModule={setSelectedModule}
                resultFound={resultFound}
                setIsSearch={setIsSearch}
              />
            </ModalBody>
          </ModalContent>
        </Modal>
      </nav>

      {isSearch && (
        <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
          <GlobalSearch searchTerm={searchTerm} selectedModule={selectedModule} setResultfound={setResultfound} resultFound={resultFound} />
        </motion.div>
      )}
    </>
  );
}

export default Navbar;
